import LocalizationService from './LocalizationService';

export const __ = LocalizationService.translate;

export { default as LocalizationService } from './LocalizationService';
export { default as LocalizationContext } from './LocalizationContext';
